import React from 'react'
import { Link } from 'react-router-dom'
import FollowButton from './FollowButton'
/* REDUX */
import { connect } from 'react-redux'
import { loadUser } from '../../actions/user'

const loadData = ({ user_id, loadUser }) => {
	loadUser(user_id)
}


class Hero extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.user_id !== this.props.user_id) {
			loadData(nextProps)
		}
	}
	
	render() {
		
		const { user_id, user, onLogin } = this.props
		
		if (!user._id) {
			return (
				<section className="profile">
					<div className="container">
						<header className="banner">
							<div className="row d-flex align-items-center">
								<div className="col-12 col-lg-7">
									<div className="details">
										<div className="left main-img">
											<img />
										</div>
										<div className="right">
											<div className="bio">
												<span className="name"></span>
												<span className="username">@</span>
												<span className="about"></span>
											</div>
										</div>
									</div>
								</div>
								<div className="col-12 col-lg-5">
									<div className="follow">
										<div className="following">
											<span className="value"></span>
											<span className="key">Following</span>
										</div>
										<div className="followers">
											<span className="value"></span>
											<span className="key">Followers</span>
										</div>
										<button className="btn btn-follow">Follow</button>
									</div>
								</div>
							</div>
						</header>
					</div>
				</section>
			)
		}
		
		const { _id, profile_picture, name, username, headline, followers, following, social } = user
		
		const followersCount = followers ? followers.length : 0
		const followingCount = following ? following.length : 0
		
		let user_img = profile_picture && profile_picture != 'undefined' ?  profile_picture : 'https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=32da20ee-1450-44b5-ad37-04b317d18f04'
		
		const { Facebook, Twitter, Instagram, Website, Youtube } = social || {}
				
		return (
			<section className="profile">
				<div className="container">
					<header className="banner">
						<div className="row d-flex align-items-center">
							<div className="col-12 col-lg-7">
								<div className="details">
									<div className="left main-img">
										<img src={ user_img } />
									</div>
									<div className="right">
										<div className="bio">
											<span className="name">{ name }</span>
											<span className="username">@{ username }</span>
											<span className="about">{ headline }</span>
											<div className={ Facebook || Twitter || Youtube || Website ? "social-btns mt-2" : "social-btns d-none" }>
												<a href={ Facebook }><span className={ Facebook ? "social-btn" : "d-none"}>{ Facebook ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"></path></svg> : ''}</span></a>
												<a href={ Twitter }><span className={ Twitter ? "social-btn" : "d-none"}>{ Twitter ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg> : ''}</span></a>
												<a href={ Youtube }><span className={ Youtube ? "social-btn" : "d-none"}>{ Youtube ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path></svg> : ''}</span></a>
												<a href={ Website }><span className={ Website ? "social-btn" : "d-none"}>{ Website ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm179.698 160h-84.125c-7.333-37.407-19.309-72.323-35.338-102.801C369.502 81.947 412.301 120.325 435.698 168zm16.318 128h-93.713c2.191-25.905 2.339-52.521-.017-80h93.73c5.309 26.293 5.317 53.669 0 80zm-250.08 0c-2.561-26.498-2.588-53.143-.041-80h108.21c2.545 26.832 2.522 53.475-.041 80H201.936zm100.544 48c-9.351 42.053-25.298 79.912-46.48 109.243-21.183-29.332-37.129-67.19-46.48-109.243h92.96zM59.984 216h93.73c-2.201 25.679-2.361 52.28-.017 80H59.984c-5.309-26.292-5.317-53.669 0-80zm149.41-48c9.275-41.974 25.172-79.655 46.606-109.277 21.434 29.622 37.332 67.304 46.606 109.277h-93.212zm-13.63-102.801C179.736 95.677 167.759 130.593 160.427 168H76.302c23.378-47.636 66.155-86.04 119.462-102.801zM76.302 344h84.043c7.301 37.472 19.247 72.317 35.308 102.766C142.008 429.864 99.48 391.227 76.302 344zm240.045 102.766c16.061-30.449 28.007-65.294 35.308-102.766h84.043c-23.217 47.307-65.791 85.891-119.351 102.766z"></path></svg> : ''}</span></a>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 col-lg-5">
								<div className="follow">
									<div className="following">
										<span className="value">{ followingCount }</span>
										<span className="key">Following</span>
									</div>
									<div className="followers">
										<span className="value">{ followersCount }</span>
										<span className="key">Followers</span>
									</div>
									<FollowButton author_id={ username } onLogin={ onLogin } />
								</div>
							</div>
						</div>
					</header>
				</div>
			</section>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const user_id = ownProps.pathname.params.profile_id
	const {
		userById
	} = state
	const usersWrapper = userById[user_id] || { user: [] }
	const user = usersWrapper.user
	return {
		user_id,
		user
	}
}

export default connect(mapStateToProps, { loadUser })(Hero)


// WEBPACK FOOTER //
// ./src/components/Profile/Hero.js